import { render, staticRenderFns } from "./advisory-opcoes-tabela.vue?vue&type=template&id=c102fe18&scoped=true&"
import script from "./advisory-opcoes-tabela.vue?vue&type=script&lang=js&"
export * from "./advisory-opcoes-tabela.vue?vue&type=script&lang=js&"
import style0 from "./advisory-opcoes-tabela.vue?vue&type=style&index=0&id=c102fe18&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c102fe18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c102fe18')) {
      api.createRecord('c102fe18', component.options)
    } else {
      api.reload('c102fe18', component.options)
    }
    module.hot.accept("./advisory-opcoes-tabela.vue?vue&type=template&id=c102fe18&scoped=true&", function () {
      api.rerender('c102fe18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/advisory-opcoes-tabela/advisory-opcoes-tabela.vue"
export default component.exports